import { replacer, reviver } from 'src/utils/mapUtil';
import { LocalStorage } from 'quasar';
import { getUserBasedKey } from 'src/utils/cacheHelper';
import type { dynamicObj } from 'src/pages/assets';

const order_by_columns_key = 'ms_order_by_columns';

export function getSavedOrderByColumns(type: string) {
  // get all columns which are sortable
  let orderByMap = new Map();
  try {
    const value = LocalStorage.getItem(
      getUserBasedKey(getOrderByKeybyType(type)),
    ) as string;
    const newValue = JSON.parse(value, reviver);
    if (newValue) {
      orderByMap = newValue;
    }
  } catch (err) {}
  return orderByMap;
}
export function removeSortOrderFromStorage(type: string) {
  logInfo(getUserBasedKey(getOrderByKeybyType(type)));
  LocalStorage.remove(getUserBasedKey(getOrderByKeybyType(type)));
}
function getOrderByKeybyType(type: string) {
  return order_by_columns_key + '_' + type;
}

export function saveSortOrderToStorage(
  type: string,
  orderByMap: Map<string, string>,
) {
  const str = JSON.stringify(orderByMap, replacer);
  LocalStorage.set(getUserBasedKey(getOrderByKeybyType(type)), str);
}

export function makeOrderByJsonForApi(orderByMap: Map<string, string>) {
  const order_by = [] as dynamicObj[];
  for (const [field, direction] of orderByMap.entries()) {
    order_by.push({
      field,
      direction,
    });
  }

  return order_by;
}

export function convertLabel(label: string) {
  return label.replace(/_/g, ' ').replace(/\w\S*/g, (txt: string) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
